import styled from "styled-components";
import Row from "../../Shared/Kit/Row";
import Col from "../../Shared/Kit/Col";

export const Wrapper = styled(Col)`
    align-items: flex-start;
    justify-content: flex-start;
`

export const TitleContainer = styled(Row)`
    flex-direction: ${(props) => props.direction === "rtl" ? "row" : "row-reverse"};
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px 0;
    border-bottom: 1px solid ${(props) => !props.expand ? props.theme.grayz : props.theme.secondary};
    cursor: pointer;
    transition: all 300ms;
    * {
        transition: all 300ms;
    }
    .title-and-icon {
        width: calc(100% - 40px);
        padding: ${(props) => props.direction === "rtl" ? "0 0 0 20px" : "0 20px 0 0"};
        * {
            cursor: pointer;
        }
        .icon {
            width: 40px;
            height: 40px;
            border-radius: 10px;
            // background-color: ${(props) => props.theme.primary};
            svg {
                width: 24px;
                height: 24px;
                fill: ${(props) => !props.expand ? props.theme.primary : props.theme.secondary};
            }
        }
        &:hover {
            .icon {
                // background-color: ${(props) => !props.expand ? props.theme.grayz : props.theme.secondary};
                svg {
                    width: 24px;
                    height: 24px;
                    fill: ${(props) => props.theme.secondary} !important;
                }
            }
        }
        .title {
            width: ${(props) => props.hasIcon ? "calc(93% - 40px)" : "93%"};
            justify-content: ${(props) => props.direction === "rtl" ? "flex-start" : "flex-end"};
            padding: ${(props) => props.hasIcon ? " 0 18px" : " 0 18px 0 0"};
            // text-shadow: 0px 3px 20px rgba(0, 0, 0, 0.5);
            color: ${(props) => !props.expand ? props.theme.primary : props.theme.secondary};
        }
        .entrydate {
            font-size: ${(props) => props.theme.fontSizeSm};
            width: ${(props) => props.hasIcon ? "calc(7% - 8px)" : "7%"};
            justify-content: "flex-end"
            padding: ${(props) => props.hasIcon ? " 0 0 0 18px" : " 0 0 0 18px"};
            color: ${(props) => !props.expand ? props.theme.primary : props.theme.secondary};
        }
    }
    .arrow-icon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        // background-color: ${(props) => !props.expand ? props.theme.grayz : props.theme.primary};
        svg {
            width: 40px;
            height: 40px;
            fill: ${(props) => !props.expand ? props.theme.primary : props.theme.secondary};
        }
    }
    &:hover {
        .arrow-icon {
            // background-color: ${(props) => !props.expand ? props.theme.grayz : props.theme.secondary};
            svg {
                width: 40px;
                height: 40px;
                fill: ${(props) => props.theme.secondary} !important;
            }
        }
        .title {
            text-shadow: 0px 3px 13px rgba(0, 0, 0, 0.5);
            color: ${(props) => props.theme.secondary};
        }
        .entrydate {
            color: ${(props) => props.theme.secondary};
        }
    }
    @media(max-width: ${props => props.theme.xs}){
        .title-and-icon {
            padding: 0;
        }
    }
`
export const DescriptionContainer = styled(Row)`
    align-items: flex-start;
    > div {
        padding: ${(props) => props.hasComponent ? "25px 0" : "25px 60px 25px 0"};
        gap: 10px;
    }
    * {
        text-align: justify;
    }
    ul {
        width: 100%;
        margin-top: 0;
    }
    li {
        &::marker {
            font-size: 10px;
        }
    }
    transition: all ${(props) => !props.expand ? "600ms" : "2500ms"};
    //motion
    max-height: 0;
    overflow-y: auto;
    .link{
        background-color: ${(props) => !props.expand ? props.theme.primary : props.theme.secondary};
        color: ${(props) => !props.expand ? props.theme.primary : props.theme.white};
        padding: 6px;
        border-radius: 4px;
    }
    @media(max-width: ${props => props.theme.xs}){
        > div {
            padding: ${(props) => props.hasComponent ? "20px 0" : "20px 40px 20px 0"};
        }
        ul {
            padding-right: 30px;
        }
    }
`
export const Description = styled(Row)`
    align-items: flex-start;
    > div:first-child {
        width: calc(100% - 500px);
    }
`